<template>
  <i :class="['mdi', `mdi-${name}`, iconClass]" :style="iconStyle" aria-hidden="true"></i>
</template>

<script>
export default {
  name: 'ChatIcon',
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 24 },
    color: { type: String, default: 'currentColor' },
    rotate: { type: Number, default: 0 },
    iconClass: { type: String, default: '' }
  },
  computed: {
    iconStyle() {
      return {
        fontSize: typeof this.size === 'number' ? `${this.size}px` : this.size,
        color: this.color,
        transform: this.rotate ? `rotate(${this.rotate}deg)` : undefined,
        display: 'inline-block',
        lineHeight: 1,
        verticalAlign: 'middle'
      }
    }
  }
}
</script>
